import {
  PERITADOR_ACT_POST_REQUESTS_BEGIN,
  PERITADOR_ACT_POST_REQUESTS_SUCCESS,
  PERITADOR_ACT_POST_REQUESTS_FAILURE,
  PERITADOR_ACT_POST_REQUESTS_DISMISS_ERROR,
  ACT_REQUESTS_MODE_CRUD_CHANGE
} from './constants'
import { REACT_APP_PERITADOR_API } from '../../../common/config'
import axios from 'axios'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function actPostRequests(args = {}, callback = () => {}) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PERITADOR_ACT_POST_REQUESTS_BEGIN
    })

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.post(REACT_APP_PERITADOR_API + '/requests', args)
      doRequest.then(
        res => {
          dispatch({
            type: PERITADOR_ACT_POST_REQUESTS_SUCCESS,
            data: res.data
          })
          callback('CREATE', true)
          resolve(res)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: PERITADOR_ACT_POST_REQUESTS_FAILURE,
            data: { error: err }
          })
          callback('CREATE', false, err)
          reject(err)
        }
      )
    })

    return promise
  }
}

export function actionChangeRequestsProps(props) {
  return dispatch => {
    dispatch({
      type: ACT_REQUESTS_MODE_CRUD_CHANGE,
      props: props
    })
  }
}

export function saveRequestFromDialog(clientId) {
  return (dispatch, getState) => {
    const { peritador, common} = getState()
    const { requestDialogClient, requestDialogService } = peritador
    const {user:{integrationData}} = common

    let body = {
      serviceDate: new Date().toUTCString(),
      servicePatent: requestDialogService.patente,
      serviceAddress: {
        address: '',
        location: ''
      },
      customer: {
        identifierType: requestDialogClient?.doctype,
        identifier: requestDialogClient?.document,
        name: requestDialogClient?.firstname,
        lastname: requestDialogClient?.lastname,
        contact: requestDialogClient?.phone,
        email: requestDialogClient?.email
      },
      idAgent: 0,
      observations: '',
      statusId: '1',
      reasonReject: '',
      typeRequest: 'automatic',
      car_lot_id: requestDialogService?.carLot.value,
      client_id: clientId ? clientId : requestDialogClient?.id,
      branch_office_id: requestDialogService?.branchOffice.value,
      origin_channel_id: requestDialogService?.originChannel.value,
      origin_request_type: 'Manual',
      email: '',
      external_id: (requestDialogClient?.lead_id ? requestDialogClient?.lead_id : integrationData?.external_id) || null,
      origin: (requestDialogClient?.lead_id ? 'lead' : integrationData?.origin) || null,
      target: (requestDialogClient?.lead_id ? 'request' : integrationData?.target) || null,
      platform: (requestDialogClient?.lead_id ? 'asofix' : integrationData?.platform) || null,
    }

    return dispatch(actPostRequests(body))
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActPostRequestsError() {
  return {
    type: PERITADOR_ACT_POST_REQUESTS_DISMISS_ERROR
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_POST_REQUESTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actPostRequestsPending: true,
        actPostRequestsSuccess: false,
        actPostRequestsError: null
      }

    case PERITADOR_ACT_POST_REQUESTS_SUCCESS:
      // The request is success
      return {
        ...state,
        actPostRequestsPending: false,
        actPostRequestsSuccess: true,
        actPostRequestsError: null,
        postedRequest:action.data
      }

    case PERITADOR_ACT_POST_REQUESTS_FAILURE:
      // The request is failed
      return {
        ...state,
        actPostRequestsPending: false,
        actPostRequestsSuccess: false,
        actPostRequestsError: action.data.error
      }

    case PERITADOR_ACT_POST_REQUESTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actPostRequestsError: null
      }

    default:
      return state
  }
}
